import 'jquery';
import 'jquery-ui-sortable-npm';
import Turbolinks from 'turbolinks';

import initPersonLogoUpload from '../../Shared/person-logo';
import { Navigation } from '../../Shared/navigation';

export default function initTeamEditor() {
	initPersonLogoUpload();

	let $teamList = $('.team-list.team-list--editable');

	(<any>$teamList).sortable({
		axis: 'y',
		items: '.team-list-item--sortable',
		handle: '.btn-team-order',
		opacity: 0.7,
		stop: function () {
			var sorted = (<any>$teamList).sortable("toArray", { attribute: "data-key" });
			$.ajax({
				data: {
					keys: sorted,
					project: $('#project').val()
				},
				type: 'POST',
				url: '/config/people/teamorder'
			});
		}
	});

	const $modal = $('#team-member-modal');

	$('.team-member-btn').click(function (e) {
		e.preventDefault();

		const href = $(this).attr('href');

		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);
			$modal.modal({ focus: false });
		});
	});

	var initTeamMemberForm = function () {
		var $form = $modal.find('#team-member-form');

		$form.on('submit', function (e) {
			e.preventDefault();

			if ($form.validate().form()) {
				$.ajax({
					data: $form.serialize(),
					type: $form.attr('method'),
					url: $form.attr('action'),
					contentType: 'application/x-www-form-urlencoded',
					success: function (response) {
						$modal.modal('hide');
						Navigation.reload();
					},
					error: function (response) {
						$modal.find('.modal-body').empty().html(response.responseText);
						initTeamMemberForm();
					}
				});
			}
		});
	};

	$modal.on('show.bs.modal', function (e) {
		initTeamMemberForm();
	});

	$modal.on('hidden.bs.modal', function (e) {
		$modal.find('#team-member-form').off('submit');
	});

	$('.delete-team-member-form').on('submit', function (e) {
		e.preventDefault();

		if (confirm('Are you sure?')) {
			var $this = $(this);
			$.ajax({
				url: $this.attr('action'),
				type: "POST",
				data: $(this).serialize(),
				success: function (data) {
					Navigation.reload();
				}
			});
		}
	});
}
